import{supabase}from'../api/supabaseClient.js';
const norm=v=>String(v||'').trim().toUpperCase();
function sectorKey(sector='',industry=''){
 const s=norm(sector),i=norm(industry);if(/SEMICONDUCTOR/.test(i))return'SEMIS';
 if(/TECH/.test(s))return'TECH';if(/COMMUNICATION/.test(s))return'COMM';if(/CONSUMER CYCLICAL|CONSUMER DISCRETIONARY/.test(s))return'CONS_DISC';if(/FINANC/.test(s))return'FIN';if(/INDUSTR/.test(s))return'IND';if(/HEALTH/.test(s))return'HEALTH';if(/ENERGY/.test(s))return'ENERGY';if(/CONSUMER DEFENSIVE|CONSUMER STAPLE/.test(s))return'STAPLES';if(/UTILIT/.test(s))return'UTIL';if(/REAL ESTATE/.test(s))return'REAL_ESTATE';return null;
}
async function loadTickerHistory(ticker,limit=40){
 const{data,error}=await supabase.from('market_history_point').select('ticker,as_of,close,volume,verification_status').eq('ticker',ticker).eq('verification_status','VERIFIED').order('as_of',{ascending:false}).limit(limit);
 return error?[]:(data||[]);
}
export async function loadOwnedMarketContext(holdings=[]){
 const tickers=[...new Set((holdings||[]).filter(h=>h&&h.is_active!==false&&!h.closed_at).map(h=>norm(h.ticker)).filter(Boolean))];
 if(!tickers.length)return{histories:{},sectorKeys:{}};
 const[marketSets,companies]=await Promise.all([
  Promise.all(tickers.map(t=>loadTickerHistory(t,40))),
  supabase.from('company').select('ticker,sector,industry').in('ticker',tickers)
 ]);
 const histories={};for(const rows of marketSets)for(const r of rows){const t=norm(r.ticker);if(!t)continue;(histories[t]??=[]).push({date:r.as_of?.slice(0,10)||'',close:Number(r.close),volume:r.volume==null?null:Number(r.volume)});}
 const sectorKeys={};if(!companies.error)for(const c of companies.data||[]){const k=sectorKey(c.sector,c.industry);if(k)sectorKeys[norm(c.ticker)]=k;}
 return{histories,sectorKeys};
}
